import PageWrapper from 'components/utils/PageWrapper';
import Connection from 'pages/Connection';

export const connectionRoutes = {
    path: '/connection',
    element: (
        <PageWrapper titleId="common_connection">
            <Connection />
        </PageWrapper>
    ),
};
